import {Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

const ComplementaryInformation = styled(Typography)({
  fontSize: 12,
  color: 'grey'
});

export default ComplementaryInformation;
